import React from 'react';

const SKILLS = [
  // Languages
  { name: 'Java',       icon: 'devicon-java-plain colored',          category: 'Languages' },
  { name: 'TypeScript', icon: 'devicon-typescript-plain colored',     category: 'Languages' },
  { name: 'JavaScript', icon: 'devicon-javascript-plain colored',     category: 'Languages' },
  { name: 'Go',         icon: 'devicon-go-plain colored',             category: 'Languages' },
  { name: 'Python',     icon: 'devicon-python-plain colored',         category: 'Languages' },
  // Frameworks
  { name: 'React',      icon: 'devicon-react-original colored',       category: 'Frameworks' },
  { name: 'Angular',    icon: 'devicon-angularjs-plain colored',      category: 'Frameworks' },
  { name: 'Node.js',    icon: 'devicon-nodejs-plain colored',         category: 'Frameworks' },
  { name: 'Express',    icon: 'devicon-express-original',             category: 'Frameworks' },
  { name: 'Spring Boot',icon: 'devicon-spring-plain colored',         category: 'Frameworks' },
  // Tools
  { name: 'Docker',     icon: 'devicon-docker-plain colored',         category: 'Tools' },
  { name: 'Git',        icon: 'devicon-git-plain colored',            category: 'Tools' },
  { name: 'Linux',      icon: 'devicon-linux-plain',                  category: 'Tools' },
  { name: 'PostgreSQL', icon: 'devicon-postgresql-plain colored',     category: 'Tools' },
  { name: 'MongoDB',    icon: 'devicon-mongodb-plain colored',        category: 'Tools' },
  { name: 'Grafana',    icon: 'devicon-grafana-plain colored',        category: 'Tools' },
];

const categories = ['Languages', 'Frameworks', 'Tools'];

const Skills = () => (
  <section id="skills" className="section">
    <div className="container">
      <p className="section-label">Stack</p>
      <h2 className="section-title">Skills & Technologies</h2>

      <div className="skills-categories">
        {categories.map((cat) => (
          <div key={cat}>
            <p className="skills-category-label">{cat}</p>
            <div className="skills-grid">
              {SKILLS.filter((s) => s.category === cat).map((skill) => (
                <div key={skill.name} className="skill-chip">
                  <i className={skill.icon} aria-hidden="true" />
                  <span className="skill-chip-label">{skill.name}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
